module.exports = __webpack_public_path__ + "img/cylinder _chart.304260d6.svg";